const DELETE_TRANSACTIONS_TASKS_KEY = "deleteTransactionsTasks"

export type DeleteTransactionsView = "teacher" | "schoolAdmin"

export interface IPersistedDeleteTransactionsTask {
  view: DeleteTransactionsView
  scopeId: number
  taskId: string
  count: number
  timestamp: number
}

const isPersistedTask = (
  value: unknown
): value is IPersistedDeleteTransactionsTask => {
  if (typeof value !== "object" || value === null) return false

  const task = value as Record<string, unknown>
  return (
    (task.view === "teacher" || task.view === "schoolAdmin") &&
    typeof task.scopeId === "number" &&
    typeof task.taskId === "string" &&
    typeof task.count === "number" &&
    typeof task.timestamp === "number"
  )
}

const readTasks = (): IPersistedDeleteTransactionsTask[] => {
  try {
    const parsed: unknown = JSON.parse(
      localStorage.getItem(DELETE_TRANSACTIONS_TASKS_KEY) ?? "[]"
    )
    return Array.isArray(parsed) ? parsed.filter(isPersistedTask) : []
  } catch {
    return []
  }
}

const writeTasks = (tasks: IPersistedDeleteTransactionsTask[]) => {
  try {
    localStorage.setItem(DELETE_TRANSACTIONS_TASKS_KEY, JSON.stringify(tasks))
  } catch {
    // Storage unavailable: the task is still tracked for this page visit.
  }
}

const isOther =
  (view: DeleteTransactionsView, scopeId: number) =>
  (task: IPersistedDeleteTransactionsTask) =>
    task.view !== view || task.scopeId !== scopeId

export const getPersistedDeleteTransactionsTask = (
  view: DeleteTransactionsView,
  scopeId: number
) => readTasks().find((task) => !isOther(view, scopeId)(task)) ?? null

export const persistDeleteTransactionsTask = (
  task: IPersistedDeleteTransactionsTask
) => {
  writeTasks([
    ...readTasks().filter(isOther(task.view, task.scopeId)),
    task,
  ])
}

export const clearPersistedDeleteTransactionsTask = (
  view: DeleteTransactionsView,
  scopeId: number
) => {
  writeTasks(readTasks().filter(isOther(view, scopeId)))
}
